<template>
  <details-grid
    :title="title"
    :header="header.toUpperCase()"
    :data-header="header"
    :data-repo="repository"
    :max-length="computeMaxLengthFields"
  >
    <template #actions>
      <b-btn
        :class="`btn btn--x-smaller btn--transparent${
          isEditMode ? ' active' : ''
        }`"
        type="button"
        variant="secondary"
        size="sm"
        @click="onEdit()"
        :disabled="isEditMode"
        :title="`Modifica qui ''${header.toLocaleLowerCase()}''`"
        v-if="edit === true"
      >
        <base-icon name="arrow_in" width="20" height="20" />
        {{ isEditMode ? "Modifica in corso" : "Modifica" }}
      </b-btn>
      <b-btn
        class="btn btn--x-smaller btn--transparent"
        type="button"
        variant="secondary"
        size="sm"
        @click="shortcut.click()"
        :disabled="isEditMode"
        v-if="shortcut.click"
        :title="`Vai alla pagina di ''${shortcut.label.toLowerCase()} ${header.toLocaleLowerCase()}''`"
      >
        <base-icon name="arrow_ext" width="20" height="20" />
        {{ shortcut.label }}
      </b-btn>
      <b-btn
        :class="`btn btn--x-smaller btn--transparent${
          creatable ? ' active' : ''
        }`"
        type="button"
        variant="secondary"
        size="sm"
        :disabled="creatable"
        @click="onCreate()"
        v-if="create === true"
        :title="`Crea qui ''${header.toLocaleLowerCase()}''`"
      >
        <base-icon name="arrow_in" width="20" height="20" />
        {{ creatable ? "Creazione in corso" : "Crea" }}
      </b-btn>
      <!-- <b-btn
        variant="lisaweb"
        size="sm"
        @click="shortcut_replace.click()"
        v-if="replace === true"
      >
        {{ shortcut_replace.label }}
      </b-btn> -->
    </template>
    <validation-observer
      ref="observer"
      tag="div"
      v-slot="{ invalid, handleSubmit }"
    >
      <div class="details-card custom-grid-wrapper">
        <template v-for="(field, index) in fields">
          <!-- LEFT -->
          <template>
            <div
              :class="{
                even: index % 2 === 0,
                odd: index % 2 !== 0,
                'grid-item-label': true,
              }"
              v-if="hasLabels"
              :key="`if_1_${index}`"
            >
              <strong>{{ labels[rep][field.label] }}</strong>
            </div>
            <div
              :class="{
                even: index % 2 === 0,
                odd: index % 2 !== 0,
                'grid-item-label': true,
              }"
              v-else
              :key="`else_1_${index}`"
            >
              <strong>{{ field.label }}</strong>
            </div>
          </template>
          <!-- LEFT -->
          <!-- RIGHT -->
          <template>
            <div
              :class="{
                even: index % 2 === 0,
                odd: index % 2 !== 0,
                'grid-item-value': true,
              }"
              v-if="!isEditMode && !isCreateMode"
              :key="`if_2_1_${index}`"
            >
              <template v-if="!field.isLink">
                <template v-if="priceContainers.includes(header)">
                  <span v-html="alignPrice(field)"></span>
                </template>
                <template v-else>
                  <span v-html="texts(field)"></span>
                </template>
              </template>
              <span v-for="(link, index) in texts(field)" :key="index">
                <template v-if="link.id">
                  <b-link @click="onLink(link.id, link.caption)">
                    {{ link.caption }}
                  </b-link>
                </template>
                <template v-else>
                  {{ link.caption }}
                </template>
              </span>
            </div>
            <div
              :class="{
                even: index % 2 === 0,
                odd: index % 2 !== 0,
                'grid-item-value': true,
              }"
              v-if="isCreateMode"
              :key="`if_2_2_${index}`"
            >
              <base-input
                v-if="
                  ['text', 'tel'].includes(getType(field)) &&
                  field.value !== 'attributables.NINO'
                "
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                :type="field.type || 'text'"
                v-model="form[field.value]"
                :rules="field.rules || {}"
                :maxlength="`${field.maxlength ?? '50'}`"
              ></base-input>
            </div>
            <div
              :class="{
                even: index % 2 === 0,
                odd: index % 2 !== 0,
                'grid-item-value': true,
              }"
              v-if="isEditMode"
              :key="`if_2_3_${index}`"
            >
              <base-input
                v-if="
                  ['text', 'tel'].includes(getType(field)) &&
                  field.value !== 'attributables.NINO'
                "
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                :type="field.type || 'text'"
                v-model="form[field.value]"
                :rules="field.rules || {}"
                :maxlength="`${field.maxlength ?? '50'}`"
              ></base-input>
              <base-dynamic-input
                v-else-if="
                  getType(field) === 'text' &&
                  field.value === 'attributables.NINO'
                "
                :isAssistence="roles.includes('admin-assistenza')"
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                :type="field.type || 'text'"
                v-model="form[field.value]"
                controlType="text"
                textcase="upper"
                :rules="field.rules || {}"
              />
              <base-select
                v-else-if="
                  field.model &&
                  ['select', 'checkbox'].includes(getType(field))
                "
                label=""
                :vid="field.option"
                :id="`input-2-${index}`"
                :name="`input-2-${index}`"
                :options="options[field.model]"
                v-model="form[field.model]"
                :rules="field.rules || {}"
              ></base-select>

              <base-select
                v-else-if="
                  !field.option &&
                  !field.options &&
                  ['select', 'checkbox'].includes(getType(field))
                "
                label=""
                :vid="field.value"
                :id="`input-1-${index}`"
                :name="`input-1-${index}`"
                :options="options[field.value]"
                v-model="form[field.value]"
                :rules="field.rules || {}"
              ></base-select>

              <base-select
                v-else-if="
                  field.option &&
                  !field.options &&
                  ['select', 'checkbox'].includes(getType(field))
                "
                label=""
                :vid="field.option"
                :id="`input-2-${index}`"
                :name="`input-2-${index}`"
                :options="options[field.option]"
                v-model="form[field.option]"
                :rules="field.rules || {}"
              ></base-select>

              <base-select
                v-else-if="
                  field.options &&
                  ['select', 'checkbox'].includes(getType(field))
                "
                label=""
                :vid="field.option"
                :id="`input-2-${index}`"
                :name="`input-2-${index}`"
                :options="options[field.option]"
                v-model="form[field.option]"
                :rules="field.rules || {}"
              ></base-select>

              <base-datepicker
                v-else-if="getType(field) === 'datepicker'"
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                v-model="form[field.value]"
                :rules="field.rules || {}"
                :allowPaste="
                  Object.hasOwnProperty.call(field, 'allowPaste')
                    ? field.allowPaste
                    : false
                "
              ></base-datepicker>

              <base-textarea
                v-else-if="getType(field) === 'textarea'"
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                v-model="form[field.value]"
                :rules="field.rules || {}"
              ></base-textarea>

              <base-currency
                v-else-if="getType(field) === 'currency'"
                :vid="field.value"
                :id="`input-${index}`"
                :name="`${field.label}`"
                v-model="form[field.value]"
                :rules="field.rules || {}"
                :options="{
                  currency: 'EUR',
                  locale: 'it-IT',
                  precision: 2,
                }"
              />

              <div v-else>
                Input type {{ getType(field) }} not implemented
              </div>
            </div>
          </template>
          <!-- RIGHT -->
        </template>
      </div>
      <div
        :class="`mt-2 justify-content-between align-items-center ${
          isEditMode ? ' d-flex' : ''
        }`"
        v-show="isEditMode"
      >
        <b-btn
          class="btn btn--x-smaller btn--transparent btn-reset"
          size="sm"
          @click="editable = false"
          :disabled="!isEditMode"
          style="min-width: 85px"
        >
          Annulla
        </b-btn>
        <b-btn
          variant="lisaweb"
          class="btn btn--x-smaller"
          size="sm"
          @click="handleSubmit(onSave($event))"
          :disabled="invalid || !isEditMode"
          style="min-width: 85px"
        >
          Salva
        </b-btn>
      </div>
      <div
        :class="`mt-2 justify-content-between align-items-center ${
          isCreateMode ? ' d-flex' : ''
        }`"
        v-show="isCreateMode"
      >
        <b-btn
          class="btn btn--x-smaller btn--transparent btn-reset"
          size="sm"
          @click="creatable = false"
          :disabled="!create"
          style="min-width: 85px"
        >
          Annulla
        </b-btn>
        <b-btn
          variant="lisaweb"
          class="btn btn--x-smaller"
          size="sm"
          @click="handleSubmit(onSubmitCreate($event))"
          :disabled="!create"
          style="min-width: 85px"
        >
          Salva
        </b-btn>
      </div>
    </validation-observer>
  </details-grid>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import DetailsGrid from "@/components/DetailsGrid";
import BaseCurrency from "@/components/form/BaseCurrency";
import BaseInput from "@/components/form/BaseInput";
import BaseDynamicInput from "@/components/form/BaseDynamicInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseTextarea from "@/components/form/BaseTextarea";
import { getInputType } from "@/utils/forms";
import {
  alignPrice,
  priceColumnWidth,
  toLocaleCurrency,
  toLocaleDecimal,
  toLocaleInteger,
} from "@/utils/strings";
import { mapGetters } from "vuex";
import moment from "moment";

moment.locale("it");

export default {
  data() {
    return {
      priceContainers: [
        `Premi`,
        `Premio`,
        `Provvigioni Agenzia`,
        `Provvigioni Collaboratore`,
        `Importi`,
        `Coassicurazioni`,
      ],
      form: {},
      options: {},
      dataCopy: null,
      editable: false,
      creatable: false,
    };
  },
  props: {
    header: String,
    repository: String,
    edit: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    // replace: {
    //   type: Boolean,
    //   default: false,
    // },
    shortcut: {
      type: Object,
      default() {
        return { label: null, click: null };
      },
    },
    // shortcut_replace: {
    //   type: Object,
    //   default() {
    //     return { label: "", click: null };
    //   },
    // },
    title: String,
    registryId: {
      type: Number,
    },
    addressBookId: {
      type: Number,
    },
    fields: {
      type: Array,
    },
    beForm: {
      type: Object,
    },
    data: {
      type: Object,
    },
    labels: {
      type: Object,
      default() {
        return {};
      },
    },
    fieldsToHideWhenBlank: {
      type: Array,
    },
    fieldsToHide: {
      type: Array,
    },
  },
  components: {
    BaseIcon,
    DetailsGrid,
    BaseCurrency,
    BaseInput,
    BaseDynamicInput,
    BaseSelect,
    BaseDatepicker,
    BaseTextarea,
  },
  beforeMount() {
    this.dataCopy = Object.assign({}, this.data);
  },
  created() {},
  methods: {
    getInputType,
    prepareForm() {
      let pForm = Object.assign({}, this.form);
      for (const key in pForm) {
        const spl = key.split(".");
        if (spl.length > 1) {
          // not base attribute eg: insurer_id
          let new_key;
          // if field has model prop, use this for submit
          let found = this.fields.find(
            (elem) => elem.value === key || (elem.model && elem.model === key),
          );
          if (found.model) {
            new_key = `attribute_${found.model
              .split(".")
              .slice(1)
              .join(".")}_value`;
          } else {
            new_key = `attribute_${spl.slice(1).join(".")}_value`;
          }

          Object.defineProperty(
            pForm,
            new_key,
            Object.getOwnPropertyDescriptor(this.form, key),
          );
          delete pForm[key];
        }
      }
      return pForm;
    },
    onEdit(e) {
      this.fields.forEach((field) => {
        console.debug("OnEdit: ", e);
        if (field.type === "select") {
          this.options[field.option] = field.options;
          if (field.option === "attributables.CHAN") {
            const chanText = this.dataCopy.attributables.CHAN;
            const CHAN_arr = [
              {
                text: "E-mail",
                value: 0,
              },
              {
                text: "Posta",
                value: 1,
              },
              {
                text: "SMS",
                value: 2,
              },
              {
                text: "Telefono",
                value: 3,
              },
              {
                text: "No Avviso",
                value: 4,
              },
              {
                text: "Tramite Capo Gruppo",
                value: 5,
              },
            ];
            const selectedObject = CHAN_arr.find(
              (item) => item.text === chanText,
            );
            this.dataCopy.attributables.CHAN = selectedObject;
            if (this.dataCopy?.attributables?.CHAN?.value != null) {
              this.form[field.option] = this.dataCopy.attributables.CHAN.value;
            }
          } else {
            this.form[field.option] = this.dataCopy[field.option].value;
          }
        } else {
          let value;
          let parts = field.value.split(".");
          let length = parts.length;
          if (field.option) {
            value =
              typeof this.dataCopy[field.option] === "object"
                ? this.dataCopy[field.option].value
                : this.dataCopy[field.option];
          } else {
            // if status && relation, extract info from the relation, filtering by status value:
            if (![null, undefined].includes(field.status) && field.relation) {
              // console.debug("onEdit relation!!!!!!!");
              let relationData = this.dataCopy[field.relation];
              let repo = this.repository.split("_").join("");
              let rd = this.getRelationDataByStatus(
                relationData,
                `status_${repo}`,
                field.status,
              );
              if (rd) {
                //found relation data for given status
                if (length > 1) {
                  value = parts.reduce((acc, part) => acc && acc[part], rd);
                } else {
                  value = rd[field.value];
                }
              }
            } else {
              // console.debug("onEdit normal!!!!!!!");
              if (length > 1) {
                value = parts.reduce(
                  (acc, part) => acc && acc[part],
                  this.dataCopy,
                );
              } else {
                value = this.dataCopy[field.value];
              }
            }
          }
          this.setOptions(field);
          let key = field.option || field.model || field.value;
          if (this.options[key]) {
            let options = this.options[key].find((elem) => {
              return elem.text === value || elem.value === value;
            });
            if (![null, undefined].includes(options)) {
              value = options.value;
            }
          }

          if (this.getType(field) == "datepicker" && value) {
            value = value ? value.split("/").reverse().join("-") : "";
            this.form[field.value] = value;
          }
          if (field.option) {
            this.form[field.option] = value;
          } else if (field.model) {
            this.form[field.model] = value;
          } else {
            this.form[field.value] = value;
          }
        }
      });
      this.editable = true;
    },
    onSave(e) {
      console.debug("input onSave", e, this.fields);
      this.editable = false;
      const preparedForm = this.prepareForm();
      // console.debug("preparedForm");
      // console.debug(preparedForm);
      this.$emit(
        "update",
        preparedForm,
        this.repository,
        this.title,
        this.addressBookId,
      );
    },
    onCreate() {
      this.creatable = true;
    },
    onSubmitCreate() {
      let payload = {};
      if (this.repository == "address_book") {
        const status_addressbook = this.fields[0].status;
        this.$set(payload, `status_addressbook`, status_addressbook);
        this.$set(payload, `registry`, {
          [this.registryId]: {},
        });
        for (const [key, value] of Object.entries(this.form)) {
          for (const field of this.fields) {
            if (key === field.value) {
              const spl = key.split(".");
              this.$set(payload, `attribute_${spl[1]}_value`, value);
            }
          }
        }
        this.$emit("create", payload, this.repository, this.title);
        this.creatable = false;
      }
    },
    /**
     * Set a value based on a dot-notation key.
     *
     * @param obj
     * @param keys
     * @param value
     */
    setValue(obj, keys, value) {
      keys = typeof keys === "string" ? keys.split(".") : keys;
      const key = keys.shift();
      if (keys.length === 0) {
        obj[key] = value;
        return;
      } else if (!Object.hasOwnProperty.call(obj, key)) {
        obj[key] = {};
      }
      this.setValue(obj[key], keys, value);
    },
    getRelationDataByStatus(data, statusName, statusValue) {
      return data
        ? data.filter((elem) => {
            return elem[statusName].value == statusValue;
          })[0]
        : null;
    },
    getRelationIndexByStatus(data, statusName, statusValue) {
      return data
        ? data.findIndex((elem) => {
            return elem[statusName].value == statusValue;
          })
        : -1;
    },
    getType(field) {
      let type = field?.type ?? "text";
      let f =
        this.beForm[this.repository][field.label] ||
        this.beForm[this.repository][`attribute_${field.label}_value`];
      if (f) {
        type = this.getInputType(f);
      }
      return type;
    },
    setOptions(field) {
      // console.info("setOptions");
      let type = "text";
      let f;
      if (this.beForm[this.repository]) {
        f =
          this.beForm[this.repository][field.option] ||
          this.beForm[this.repository][field.label] ||
          this.beForm[this.repository][`attribute_${field.label}_value`];
      }
      if (f) {
        type = this.getInputType(f);
      }
      if (["select", "checkbox"].includes(type)) {
        let key = field.option || field.model || field.value;
        this.options[key] = f.options;
        this.form[key] = f.value;
      }
    },
    onLink(id, caption) {
      console.debug(`onLink id: ${id} - ${caption}`);
      this.$emit("modal", id, caption);
    },
    alignPrice(field) {
      return alignPrice(this.texts(field), +this.computeMaxLengthFields);
    },
    ...mapGetters("auth", ["provinceByCouncil", "countryByCouncil"]),
  },
  computed: {
    ...mapGetters("auth", ["roles"]),
    rep() {
      return this.repository;
    },
    isEditMode() {
      return this.editable;
    },
    isCreateMode() {
      return this.creatable;
    },
    texts() {
      return (field) => {
        if (!field.value && !field.virtual) {
          console.info(`missing field.value or field.virtual`);
          console.debug(field);
          return "";
        }
        let value;
        let relationData;
        let parts = [];
        // c'è l'attributo "virtual", e non è stato (giustamente) valorizzato l'attributo "value": split va in errore
        if (field.value) {
          parts = field.value.split(".");
        }
        let length = parts.length;
        if (field.option) {
          value =
            typeof this.dataCopy[field.option] === "object"
              ? this.dataCopy?.[field.option]?.text ?? ""
              : parts.reduce((acc, part) => acc && acc[part], this.dataCopy);
        } else {
          // if status && relation, extract info from the relation, filtering by status value:
          // handle "dot notation" relation
          if (field.status != null && field.relation) {
            let relationData;
            let partsR = field.relation.split(".");
            if (partsR.length > 1) {
              relationData = partsR.reduce(
                (acc, part) => acc && acc[part],
                this.dataCopy,
              );
            } else {
              relationData = this.dataCopy[field.relation];
            }
            let repo = this.repository.split("_").join("");
            let rd = this.getRelationDataByStatus(
              relationData,
              `status_${repo}`,
              field.status,
            );
            if (rd) {
              //found relation data for given status
              if (length > 1) {
                value = parts.reduce((acc, part) => acc && acc[part], rd);
              } else {
                value = rd[field.value];
              }
            }
          } else if (
            field.virtual &&
            !(field.virtual instanceof Function) &&
            field.relation
          ) {
            switch (field.virtual) {
              case "NEW_POLICIES":
                // Array
                value = []; // restituisco un array di number
                relationData = this.dataCopy[field.relation];
                if (relationData && relationData.length) {
                  for (const p of relationData) {
                    value.push({
                      id: p.id,
                      caption: p.number,
                    });
                  }
                } else {
                  value.push({
                    id: null,
                    caption: "--",
                  });
                }
                break;
              case "OLD_POLICY":
                // Object
                value = []; // restituisco un array di number
                relationData = this.dataCopy[field.relation];
                if (relationData && relationData.id) {
                  value.push({
                    id: relationData.id,
                    caption: relationData.number,
                  });
                } else {
                  value.push({
                    id: null,
                    caption: "--",
                  });
                }
                break;
              case "INSURANCE_POLICY_FROM_ACCOUNTING_OR_ANCILLARIES": {
                value = []; // array come per NEW_POLICIES
                const various = this.dataCopy.various_accountings;
                const ancillaries = this.dataCopy.insurance_ancillaries;

                if (various?.length) {
                  const p = various[0];
                  value = [
                    {
                      id: null,
                      caption: p.pivot?.insurance_policy_number ?? "--",
                    },
                  ];
                } else if (ancillaries?.length) {
                  const a = ancillaries[0];
                  value = [
                    {
                      id: a.insurance_policy?.id ?? null,
                      caption: a.insurance_policy?.number ?? "--",
                    },
                  ];
                } else {
                  value = [
                    {
                      id: null,
                      caption: "--",
                    },
                  ];
                }
                break;
              }
            }
          } else if (field.virtual && field.virtual instanceof Function) {
            // è una function...
            value = field.virtual(this.dataCopy);
          } else {
            if (length > 1) {
              value = parts.reduce(
                (acc, part) => acc && acc[part],
                this.dataCopy,
              );
            } else {
              value = this.dataCopy[field.value];
            }
          }
        }
        // if (field.type === "currency") {
        //   return toLocaleCurrency(value);
        // } else if (field.type === "datepicker" && value) {
        //   return moment(value).format("DD/MM/YYYY");
        // }
        if (Object.hasOwnProperty.call(field, "type")) {
          // 99% è un customattribute (a meno di altro contesto oltre a questo che lo imposterà)
          // REVIEW: nei casi futuribili, non è detto che si debba fare "return", quindi andrebbe rivisto
          switch (field.type) {
            case "currency":
              return toLocaleCurrency(parseFloat(value));
            // break;
            case "datepicker":
              return value ? moment(value).format("DD/MM/YYYY") : null;
            // break;
            case "decimal":
              return toLocaleDecimal(value);
            // break;
            case "number":
              return toLocaleInteger(value);
            // break;
            case "radio":
              // ATTENZIONE che in realtà è nato unicamente come "scelta SI/NO"
              return value == "Y" ? "SI" : "NO";
            // break;
            default:
              break;
          }
        }
        // handle specific cases here
        let found;
        // get just the last 2 elements from split
        if (value != undefined) {
          switch (field.value.split(".").slice(-2).join(".")) {
            case "attributables.NOB":
              // non mostro nulla se disegnao NATION2 e NOB è Italia
              found = this.$store.state.auth.countries.find(
                (e) => e.title == "Italia",
              );
              if (field.virtual == "NATION2" && value == found.id) {
                value = "";
                break;
              }
              found = this.$store.state.auth.countries.find(
                (e) => e.id == value,
              );
              value = found ? found.title : "";
              break;
            case "attributables.NOR":
              found = this.$store.state.auth.countries.find(
                (e) => e.id == value,
              );
              value = found ? found.title : "";
              break;
            case "attributables.POB":
            case "attributables.CITY":
            case "attributables.ISPL":
              switch (field.virtual) {
                case "PROVINCE":
                  found = this.$store.state.auth.councils.find(
                    (e) => e.code == "ZZ",
                  );
                  if (value != found.id) {
                    value = this.provinceByCouncil()(value, "code");
                  } else {
                    value = "";
                  }
                  break;
                case "NATION":
                  found = this.$store.state.auth.councils.find(
                    (e) => e.code == "ZZ",
                  );
                  if (value != found.id) {
                    value = this.countryByCouncil()(value, "title");
                  } else {
                    value = "";
                  }
                  break;
                // case "NATION2":
                //   // non mostro nulla se NOB è Italia
                //   found = this.$store.state.auth.countries.find(
                //     (e) => e.title == "Italia"
                //   );
                //   if (value == found.id) {
                //     value = "";
                //   }
                //   break;
                default:
                  // se POB ed è "Comune estero", non mostrare nulla
                  if (
                    field.value.split(".").slice(-2).join(".") ===
                    "attributables.POB"
                  ) {
                    found = this.$store.state.auth.councils.find(
                      (e) => e.code == "ZZ",
                    );
                    if (value == found.id) {
                      value = "";
                      break;
                    }
                  }
                  found = this.$store.state.auth.councils.find(
                    (e) => e.id == value,
                  );
                  value = found ? found.title : "";
                  break;
              }
              break;
            default:
              break;
          }
        }
        if (value == null) return "-";
        return value;
      };
    },
    hasLabels() {
      return Object.keys(this.labels).length && this.labels[this.rep];
    },
    computeMaxLengthFields() {
      if (!this.priceContainers.includes(this.header)) return;
      const width = priceColumnWidth(this.fields.map(this.texts));
      return width > 0 ? `${width}` : "";
    },
  },
};
</script>
